// GETTERS
export const SELECTED_PAYMENT_TERM_UNIT = 'partners/SELECTED_PAYMENT_TERM_UNIT'
export const SELECTED_REPAYMENT_METHOD = 'partners/SELECTED_REPAYMENT_METHOD'
export const SELECTED_REPAYMENT_INTEREST_METHOD =
  'partners/SELECTED_REPAYMENT_INTEREST_METHOD'
export const SELECTED_BILLING_UNIT = 'partners/SELECTED_BILLING_UNIT'
export const IS_FORM_VALID = 'partners/IS_FORM_VALID'
export const FORMAT_VALUES_TO_SEND = 'partners/FORMAT_VALUES_TO_SEND'
export const FORM_RULES = 'partners/FORM_RULES'

// MUTATIONS
export const SET_PARTNER = 'partners/SET_PARTNER'
export const SET_INFO_DIALOG = 'partners/SET_INFO_DIALOG'
export const SET_IS_EDIT_MODE = 'partners/SET_IS_EDIT_MODE'
export const SET_IS_CONFIG_NOT_FOUND = 'partners/SET_IS_CONFIG_NOT_FOUND'
export const SET_PARTNER_INFO = 'partners/SET_PARTNER_INFO'
export const SET_PARTNER_BANK_ACCOUNTS = 'partners/SET_PARTNER_BANK_ACCOUNTS'

// ACTIONS
export const GET_PARTNER = 'partners/GET_PARTNER'
export const GET_PRICING_DIALOG_INFO = 'partners/GET_PRICING_DIALOG_INFO'
export const CHANGE_IS_EDIT_MODE = 'partners/CHANGE_IS_EDIT_MODE'
export const CHANGE_IS_CONFIG_NOT_FOUND = 'partners/CHANGE_IS_CONFIG_NOT_FOUND'
export const GET_PARTNER_INFO = 'partners/GET_PARTNER_INFO'
export const GET_PARTNER_BANK_ACCOUNTS = 'partners/GET_PARTNER_BANK_ACCOUNTS'
export const UPDATE_PARTNER_INFO = 'partners/UPDATE_PARTNER_INFO'
